import {
  dealCarDatas
} from '@/cllib/sys_lib'

import {
  adjustOrderGetCar
} from '@/api/api'

const state = {
  signCar: [],
  signCarLoading: false,
  chooseRouterCar: {}
}

const getters = {
  signCar: state => state.signCar,
  signCarLoading: state => state.signCarLoading,
  chooseRouterCar: state => state.chooseRouterCar
}

const actions = {
  loadSignCar ({ dispatch }, parm) {
    dispatch('setSignCarLoading', true)
    return adjustOrderGetCar(parm).then((data) => {
      dispatch('setSignCar', dealCarDatas(data))
      dispatch('setSignCarLoading', false)
    }).catch((e) => {
      dispatch('setSignCarLoading', false)
    })
  },
  setSignCarLoading ({ commit }, data) {
    commit('setSignCarLoading', data)
  },
  setSignCar ({ commit, dispatch, getters }, data) {
    commit('setSignCar', data)
    let inSignCar = false
    getters.signCar.forEach((item) => {
      if (item.id === getters.chooseRouterCar.id) {
        inSignCar = true
      }
    })
    if (!inSignCar) {
      dispatch('setChooseRouterCar', {})
    }
  },
  setChooseRouterCar ({ commit, dispatch, getters }, data) {
    let hisId = getters.chooseRouterCar.id
    commit('setChooseRouterCar', data)
    if (data.id) {
      dispatch('setAdjustShowRouteOrderType', 'car')
      if (data.id !== hisId) {
        dispatch('loadRouterOrder')
      }
    } else {
      dispatch('setRouterOrder', [])
    }
    dispatch('setChooseOrders', {
      cabin_1: null,
      cabin_2: null,
      cabin_3: null,
      cabin_4: null,
      cabin_5: null
    })
  }
}

const mutations = {
  setSignCarLoading (state, data) {
    state.signCarLoading = data
  },
  setSignCar (state, data) {
    state.signCar = data
  },
  setChooseRouterCar (state, data) {
    state.chooseRouterCar = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/sign_cars.js